export const CLIENT_PEER_START = "client/peerStart";
export const CLIENT_PEER_STOP = "client/peerStop";
export const CLIENT_PEER_SEND = "client/peerSend";

export const CLIENT_NAME_CHANGE = "client/nameChange";
export const CLIENT_PEER_CONNECTED = "client/peerConnected";

export const CLIENT_ICON_UPDATE = "client/iconUpdate";
